import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import {
  userIsAdmin,
  userIsManager,
  getCurrentUser,
} from '../../helpers/Auth';

const UserProfileHeader = ({ profile }) => {
  const intl = useIntl();

  return (
    <header className="page-header">
      <div className="page-title">
        <h2>
          <i className="far fa-user" />
          {intl.formatMessage({ defaultMessage: 'User profile' })}
        </h2>
      </div>
      <div className="header-actions">
        {(
          profile &&
          (userIsAdmin() || userIsManager() || getCurrentUser().uuid === profile.uuid)
        ) && (
          <Button
            color="primary"
            tag={Link}
            to={getCurrentUser().uuid === profile.uuid ? '/profile/edit' : `/admin/users/${profile.uuid}/edit`}
          >
            <i className="far fa-pen" />{' '}
            {intl.formatMessage({ defaultMessage: 'Edit user' })}
          </Button>
        )}
      </div>
    </header>
  );
};

UserProfileHeader.propTypes = {
  profile: PropTypes.object,
};

UserProfileHeader.defaultProps = {
  profile: null,
};

export default UserProfileHeader;
